'use strict';

angular.module('magview')
    .controller('PrefNotesCtrl', [
      '$scope', 'prefNotesViewModel',
    function ($scope, viewModel) {
      $scope.model = new viewModel($scope.pref);
    }
  ]);
